import { companyConstants } from "../_constants";
import { companyServices } from "../_services";
import { alertActions } from ".";

export const companyActions = {
  getCompanyDetails,
  editCompanyProfile,
  getCompanyLogo,
  getDashboardDropdownData,
  getCostDashboardData
};

function getCompanyDetails() {
  return (dispatch) => {
    dispatch(request());
    companyServices.getCompanyDetails().then(
      (company) => dispatch(success(company)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: companyConstants.GET_COMPANY_DETAILS_REQUEST };
  }
  function success(company) {
    return { type: companyConstants.GET_COMPANY_DETAILS_SUCCESS, company };
  }
  function failure(error) {
    return { type: companyConstants.GET_COMPANY_DETAILS_FAILURE, error };
  }
}

function editCompanyProfile(formData) {
    return (dispatch) => {
    dispatch(request());
    companyServices.editCompanyProfile(formData).then(
      (company) => {
        dispatch(success(company));
        dispatch(alertActions.success(company.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: companyConstants.EDIT_COMPANY_PROFILE_REQUEST };
  }
  function success(company) {
    return { type: companyConstants.EDIT_COMPANY_PROFILE_SUCCESS, company };
  }
  function failure(error) {
    return { type: companyConstants.EDIT_COMPANY_PROFILE_FAILURE, error };
  }
}

function getCompanyLogo() {
  return (dispatch) => {
    dispatch(request());
    companyServices.getCompanyLogo().then(
      (logo) => dispatch(success(logo)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: companyConstants.GET_COMPANY_LOGO_REQUEST };
  }
  function success(logo) {
    return { type: companyConstants.GET_COMPANY_LOGO_SUCCESS, logo };
  }
  function failure(error) {
    return { type: companyConstants.GET_COMPANY_LOGO_FAILURE, error };
  }
}

function getDashboardDropdownData(){
  return (dispatch) => {
    dispatch(request());
    companyServices.getDashboardDropdownData().then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: companyConstants.GET_DASHBOARD_DROPDOWN_DATA_REQUEST };
  }
  function success(data) {
    return { type: companyConstants.GET_DASHBOARD_DROPDOWN_DATA_SUCCESS, data };
  }
  function failure(error) {
    return { type: companyConstants.GET_DASHBOARD_DROPDOWN_DATA_FAILURE, error };   
  }
}


function getCostDashboardData(formData) {
  return (dispatch) => {
    dispatch(request());
    companyServices.getCostDashboardData(formData).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: companyConstants.GET_COST_DASHBOARD_DATA_REQUEST };
  }
  function success(data) {
    return { type: companyConstants.GET_COST_DASHBOARD_DATA_SUCCESS, data };
  }
  function failure(error) {
    return { type: companyConstants.GET_COST_DASHBOARD_DATA_FAILURE, error };   
  }
}
